import { ComboBox } from "@xola/ui-kit";
import React from "react";
import { MessageTemplate } from "types";

interface TemplateSelectProps {
    onChange: (template: MessageTemplate) => void;
    templates?: MessageTemplate[];
    value: MessageTemplate | null;
    className?: string;
    dataTestId?: string;
}

export const TemplateSelect = ({ templates, value, onChange, dataTestId, ...rest }: TemplateSelectProps) => {
    // Stop propagation so opening / interacting with the ComboBox menu doesn't bubble up and close the
    // surrounding drawer's popover-parent click handlers.
    return (
        <div data-testid={dataTestId} onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
            <ComboBox
                isClearable
                placeholder="Load Template"
                value={value}
                options={templates}
                classNames={{ option: () => "no-translate" }}
                getOptionValue={(template: MessageTemplate) => template.id}
                getOptionLabel={(template: MessageTemplate) => template.name}
                onChange={onChange}
                {...rest}
            />
        </div>
    );
};
